import React, { useEffect, useRef, useState } from 'react'

function usePrevious(value: any) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}
function Loading() {
  const [dotLoad, setDotLoad] = useState(-1)
  const prevDot = usePrevious(dotLoad)

  const isNext = () => {
    if (prevDot) {
      return prevDot < dotLoad
    }
    return true
  }

  useEffect(() => {
    setTimeout(() => {
      setDotLoad(0)
    }, 500)
  }, [])

  useEffect(() => {
    const loop = setInterval(() => {
      if (isNext()) {
        if (dotLoad >= 2) {
          setDotLoad(dotLoad - 1)
        } else {
          setDotLoad(dotLoad + 1)
        }
      } else {
        if (dotLoad <= 0) {
          setDotLoad(dotLoad + 1)
        } else {
          setDotLoad(dotLoad - 1)
        }
      }
    }, 500)

    return () => {
      clearInterval(loop)
    }
  }, [dotLoad])
  return (
    <div className="loading-animation">
      <div className="loading-animation__dots">
        <span
          style={{ background: 'var(--primary)' }}
          className={`${dotLoad === 0 ? 'active' : ''}`}
        ></span>
        <span
          style={{ background: 'var(--primary)' }}
          className={`${dotLoad === 1 ? 'active' : ''}`}
        ></span>
        <span
          style={{ background: 'var(--primary)' }}
          className={`${dotLoad === 2 ? 'active' : ''}`}
        ></span>
      </div>
    </div>
  )
}

export default Loading
